import React, { Suspense, lazy } from 'react';
import Loading from '../LoadingComponent';

const ColorSchemeBuilder = lazy(() =>
  import(/* webpackChunkName: "ColorSchemeBuilder" */ '../../components/survey_editor/color_scheme/ColorSchemeBuilder')
);

export default function AsyncColorSchemeBuilder({...props}) {
  return (
    <Suspense fallback={<Loading />}>
      <ColorSchemeBuilder {...props} />
    </Suspense>
  );
}
